export default __webpack_public_path__ + "static/media/cocktail4.49d3accb.jpg";